module.exports = __webpack_public_path__ + "static/img/s136.515dacff.png";